import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import { useFetch } from '../../hooks/useFetch';
import { boardApi } from '../../api/board';

import Section from '../../components/layout/Section';
import PostDetail from '../../components/UI/PostDetail';
import PageTitle from '../../components/UI/PageTitle';
import MainBody from '../../components/layout/MainBody';
import Button from '../../components/UI/Button';

const PostContainer = styled.div`
	width: 900px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 100px;
`;

const ButtonsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: 10px;
	justify-content: flex-end;
	align-self: flex-end;
`;

const AnswerWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-top: 20px;
`;

export default function Post() {
	const navigate = useNavigate();
	const params = useParams();
	
	const postId = params.postId;

	const { data, loading, error } = useFetch(boardApi.getPostDetail, [postId]);
	const lastHandledError = useRef(null);

	useEffect(() => {
		if (error && error !== lastHandledError.current) {
			lastHandledError.current = error;
		
			if (error.status === 404) {
				alert('존재하지 않는 게시글입니다.');
				navigate('/board', { replace: true });
			}	
		
			if (error.status === 401) {
				alert('작성자만 조회할 수 있습니다.');
				navigate('/board', { replace: true });
			}
		}
	}, [error, navigate]);

	if (loading) return ;
	if (error) return ;

	const mainContent = {
		postType: data.postType,
		title: data.title,
		author: data.author,
		date: data.date.split('T')[0],
		content: data.content
	};

	const answers = data.answers ? data.answers : [];

	const onClickModify = () => {
		if(data.answers && data.answers.length > 0) {
			alert('답변이 등록된 게시글은 수정할 수 없습니다.');
			return;
		}
		navigate(`/board/${postId}/edit`, { state: { post: mainContent } });
	};

	const onClickDelete = () => {
		if(data.answers && data.answers.length > 0) {
			alert('답변이 등록된 게시글은 삭제할 수 없습니다.');
			return;
		}

		if(!window.confirm('정말로 게시글을 삭제하시겠습니까?')) {
			return;
		}

		boardApi.deletePost(postId)
			.then(() => {
				alert('게시글이 삭제되었습니다.');
				navigate('/board');
			})
			.catch(() => {
				alert('게시글 삭제에 실패했습니다. 다시 시도해주세요.');
			});
	};

  	return (
		<MainBody>
			<Section>
				<PostContainer>
					<PageTitle style = {{ border: 'none' }}>주문제작 및 문의사항 게시판</PageTitle>
					<PostDetail type={mainContent.postType} data={ mainContent } />
					<ButtonsWrapper>
						<Button 
							onClick={ onClickModify } 
							buttonText="수정하기"
							style={{ cursor: 'pointer' }}
							width="100px"
							height="40px"
							textSize="16px"
						/>
						<Button 
							onClick={ onClickDelete } 
							buttonText="삭제하기"
							style={{ cursor: 'pointer' }}
							width="100px"
							height="40px"
							textSize="16px"
						/>
					</ButtonsWrapper>
					{
						<AnswerWrapper>
							{answers.map((answer, index) => (
								<PostDetail key={index} type="ANSWER" data={answer} />
							))}
						</AnswerWrapper>
					}
				</PostContainer>
			</Section>
		</MainBody>
  	);
}
